import { createAccountSubmissionPreviews } from "./AccountSubmissionPreviews";

export const AccountSubmissionPreviewsOpen = createAccountSubmissionPreviews(
	"account_submissions_open",
	(account) =>
		!account.hasBeenActive && (account.status === "approved" || account.status === "review"),
);
